import { BlockItem } from "@components/atoms/BlockItem"
import { BlockWrapper } from "@components/atoms/BlockWrapper"
import { Pill } from "@components/atoms/Pill"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useEffect, useRef, useState } from "react"
import { useWindowSize } from "react-use"
import { twMerge } from "tailwind-merge"

export const meta: BlockMeta = {
  title: "Myths vs Facts Item",
}

export default defineBlock("myths-vs-facts/item", (props) => {
  const [expanded, setExpanded] = useState(false)
  const bodyRef = useRef<HTMLDivElement>(null)
  const innerBodyRef = useRef<HTMLDivElement>(null)
  const bodyHeight = useRef(0)
  const { width, height } = useWindowSize()

  useEffect(() => {
    if (bodyRef.current && innerBodyRef.current) {
      bodyHeight.current = innerBodyRef.current.offsetHeight
      // console.log('bodyHeight', bodyHeight.current)
    }
  }, [width, height])

  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.style.height = expanded ? `${bodyHeight.current}px` : "0"
    }
  }, [expanded])

  return (
    <BlockItem className="bg-beige">
      <div className={twMerge("flex w-full gap-3 justify-between items-center cursor-pointer")} onClick={() => setExpanded(!expanded)}>
        <div className="flex flex-col gap-3 justify-center items-start md:flex-row">
          <div className="shrink-0 min-w-[4.68vw]">
            <Pill className="bg-beige-dark">
              <EditableText
                as="span"
                className=""
                store="pill"
                inlineToolbar={false}
                defaultValue="Myth"
                placeholder="Myth"
              />
            </Pill>
          </div>
          <EditableText
            as="p"
            className="type-title-m w-full"
            store="title"
            inlineToolbar={false}
            defaultValue="Example heading"
            placeholder="Example heading"
          />
        </div>
        <svg className={twMerge("type-title-m shrink-0 transition-transform", expanded ? "rotate-45" : "")} style={{ width: "1.3em", height: "1.3em " }} viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9157 10.6959C11.2839 10.6959 11.5823 10.3974 11.5823 10.0292L11.5823 0.751004C11.5823 0.382814 11.8808 0.0843375 12.249 0.0843376L13.751 0.0843375C14.1192 0.0843375 14.4177 0.382815 14.4177 0.751005L14.4177 10.0292C14.4177 10.3974 14.7161 10.6959 15.0843 10.6959L24.3625 10.6959C24.7307 10.6959 25.0292 10.9943 25.0292 11.3625L25.0292 12.8645C25.0292 13.2327 24.7307 13.5312 24.3625 13.5312L15.0843 13.5312C14.7161 13.5312 14.4177 13.8296 14.4177 14.1978L14.4177 23.476C14.4177 23.8442 14.1192 24.1427 13.751 24.1427L12.249 24.1427C11.8808 24.1427 11.5823 23.8442 11.5823 23.476V14.1978C11.5823 13.8296 11.2839 13.5312 10.9157 13.5312L1.6375 13.5312C1.26931 13.5312 0.970835 13.2327 0.970835 12.8645L0.970835 11.3625C0.970835 10.9943 1.26931 10.6959 1.6375 10.6959L10.9157 10.6959Z" fill="currentColor" />
        </svg>
      </div>
      <div ref={bodyRef} className={twMerge("w-full h-0 overflow-hidden transition-all duration-500 pointer-events-none", expanded || env.admin ? "pointer-events-auto" : "")}>
        <div ref={innerBodyRef} className="w-full">
          <div className="w-full pt-6" />
          <div className="flex w-full gap-3 justify-between pt-6 border-t border-black">
            <div className="flex flex-col gap-3 justify-center items-start md:flex-row">
              <div className="shrink-0 min-w-[4.68vw]">
                <Pill className="bg-orange">
                  <EditableText
                    as="span"
                    className=""
                    store="pill"
                    inlineToolbar={false}
                    defaultValue="Fact"
                    placeholder="Fact"
                  />
                </Pill>
              </div>
              <EditableText
                as="div"
                className="type-body-m w-full md:pr-10"
                store="body"
                inlineToolbar={false}
                defaultValue="Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien. Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien."
                placeholder="Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien. Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien."
              />
            </div>
          </div>
        </div>
      </div>
    </BlockItem>
  )
})